import { DomainRegluingsFormValidationSchema } from '../../..';
import { DomainVisitors } from '../../../domains.interfaces';

export const domainRegluingsFormValidationSchema: Pick<
  DomainRegluingsFormValidationSchema,
  'forVisitor' | 'targetDomainId' | 'isAutoUpdate'
> = {
  forVisitor: [
    { required: true, message: 'Виберіть бота' },
    { type: 'enum', message: 'Бот має бути валідним значенням', enum: [DomainVisitors.Any, DomainVisitors.GoogleBot] }
  ],
  targetDomainId: [
    {
      required: true,
      message: 'Виберіть домен',
      type: 'regexp',
      pattern: /^[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12}$/gi
    }
  ],
  isAutoUpdate: [
    { required: true, message: 'Виберіть чи оновлювати переклейку для інших доменів автоматично', type: 'boolean' }
  ]
};
